import React, {useContext} from 'react';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/Help.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import PageHeader from '../components/common/PageHeader.js';
import HelpMenu from '../components/Help/HelpMenu.js';
import {toHtml} from '../components/common/utilities.js';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {Text} from '../components/common/MultilingualText.js';
import {
    frequentlyAskedQuestionsKey,
    hostsKey,
    licensesKey,
    mainMessages,
    navigationKey,
    fsaSummaryKey,
    aboutFsaKey,
    flexibleSpendingAccountsKey,
    fsaAccessKey,
    helpAboutFSASectionKey,
    helpFsaNavigationKey,
    helpFSASummaryQAKey,
    helpFSASummaryLicensesQAKey,
    helpFSASummaryHostsQAKey, helpFSASummaryAccessQAKey
} from '../assets/text/MultilingualText.js';
import fsaHumburger from '../assets/img/Help/ksm-fsa-hamburger.png';


function FSASummaryHelp(props) {
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    const bulletStyle = {
        paddingTop: 6,
        paddingBottom: 6
    };

    const helpContent = {
        'header': {
            key: fsaSummaryKey,
            default: mainMessages[siteLanguageDefault][fsaSummaryKey]
        },
        'topics': [
            {
                key: aboutFsaKey,
                default: mainMessages[siteLanguageDefault][aboutFsaKey],
                hash: '#about-fsa'
            },
            {
                key: navigationKey,
                default: mainMessages[siteLanguageDefault][navigationKey],
                hash: '#navigation'
            }
        ],
        'faq': [
            {
                key: flexibleSpendingAccountsKey,
                default: mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey],
                hash: '#flexible-spending-accounts-faq'
            },
            {
                key: licensesKey,
                default: mainMessages[siteLanguageDefault][licensesKey],
                hash: '#licenses-faq'
            },
            {
                key: hostsKey,
                default: mainMessages[siteLanguageDefault][hostsKey],
                hash: '#hosts-faq'
            },
            {
                key: fsaAccessKey,
                default: mainMessages[siteLanguageDefault][fsaAccessKey],
                hash: '#access-faq'
            }
        ]
    };

    const aboutFSAContent = localization.toLanguageString(
        helpAboutFSASectionKey,
        mainMessages[siteLanguageDefault][helpAboutFSASectionKey]
    );

    const navigationContent = localization.toLanguageString(
        helpFsaNavigationKey,
        mainMessages[siteLanguageDefault][helpFsaNavigationKey]
    );

    const fsaSummaryQA = localization.toLanguageString(
        helpFSASummaryQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryQAKey]
    );

    const licensesQA = localization.toLanguageString(
        helpFSASummaryLicensesQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryLicensesQAKey]
    );

    const hostsQA = localization.toLanguageString(
        helpFSASummaryHostsQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryHostsQAKey]
    );

    const accessQA = localization.toLanguageString(
        helpFSASummaryAccessQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryAccessQAKey]
    );

    return (
        <>
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <Row>
                    <Col xs="3">
                        <HelpMenu helpContent={helpContent}/>
                    </Col>
                    <Col xs="9">
                        <div
                            className={"k-h3"}
                            id="about-fsa"
                        >
                            <Text
                                textkey={aboutFsaKey}
                                textdefault={mainMessages[siteLanguageDefault][aboutFsaKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {aboutFSAContent.section_one}
                            </p>
                            <ul>
                                {aboutFSAContent.section_one_bullets.map((bullet, index) => <li
                                    key={'about-fsa-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="navigation"
                        >
                            <Text
                                textkey={navigationKey}
                                textdefault={mainMessages[siteLanguageDefault][navigationKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>{toHtml(navigationContent.section_one)}</p>
                            <ol type="a">
                                {navigationContent.section_one_bullets.map((bullet, index) => <li
                                    key={'about-fsa-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ol>

                            <img src={fsaHumburger}
                                 alt="ksm-fsa-summary-my-fsa-agreements"
                                 width={'350rem'}
                            />
                        </div>

                        <div className={"k-h3 header"}>
                            <Text
                                textkey={frequentlyAskedQuestionsKey}
                                textdefault={mainMessages[siteLanguageDefault][frequentlyAskedQuestionsKey]}
                            />
                        </div>
                        <hr/>
                        <div id="flexible-spending-accounts-faq">
                            <h3>
                                <Text
                                    textkey={flexibleSpendingAccountsKey}
                                    textdefault={mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {fsaSummaryQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"fsa-summary-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="licenses-faq">
                            <h3>
                                <Text
                                    textkey={licensesKey}
                                    textdefault={mainMessages[siteLanguageDefault][licensesKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {licensesQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"licenses-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="hosts-faq">
                            <h3>
                                <Text
                                    textkey={hostsKey}
                                    textdefault={mainMessages[siteLanguageDefault][hostsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {hostsQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"hosts-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="access-faq">
                            <h3>
                                <Text
                                    textkey={fsaAccessKey}
                                    textdefault={mainMessages[siteLanguageDefault][fsaAccessKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {accessQA ? accessQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"ea-access-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                }) : <></>}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default FSASummaryHelp;

